import { AlertProvider } from '@components/alerts';
import { ThemeProvider } from '@components/theme';
import { initialize as initializeAad } from '@services/aad';
import { store } from '@services/state/store';
import { LicenseManager } from 'ag-grid-enterprise';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { App } from './App';
import { installChunkReload } from './chunkReload';
import i18n from './i18n';

LicenseManager.setLicenseKey(`${process.env.AG_GRID_LICENSE_KEY}`);

// Before anything else mounts: a chunk can fail during the very first render.
installChunkReload();

const r = localStorage.getItem('logoutRedirect');
if (r) {
  localStorage.removeItem('logoutRedirect');
  window.location.href = r;
} else {
  initializeAad({
    configuration: {
      auth: {
        clientId: `${process.env.CLIENT_ID}`,
        authority: `https://${process.env.AUTHORITY_DOMAIN}/${process.env.TENANT}/B2C_1A_signup_signin`,
        knownAuthorities: [`${process.env.AUTHORITY_DOMAIN}`],
        redirectUri: `${process.env.REDIRECT_URI}`,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
      system: {},
    },
    scopes: ['openid', 'offline_access'],
    accountScopes: [`https://${process.env.TENANT}/Api/ReadWrite`],
    commentScopes: [`https://${process.env.TENANT}/Api/ReadWrite`],
    contentScopes: [`https://${process.env.TENANT}/Api/ReadWrite`],
    notificationScopes: [`https://${process.env.TENANT}/Api/ReadWrite`],
    projectScopes: [`https://${process.env.TENANT}/Api/ReadWrite`],
  });

  document.body.classList.add(`theme-${localStorage.getItem('theme') || 'light'}`);

  const rootEl = document.getElementById('root');
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl);
    root.render(
      <ReduxProvider store={store}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <AlertProvider>
              <App />
            </AlertProvider>
          </ThemeProvider>
        </I18nextProvider>
      </ReduxProvider>,
    );
  }
}
